module.exports = __webpack_public_path__ + "static/media/sta-upp.56ffefe7.mp3";